import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import './App.css';
import { Home } from './components/home';
import { Gallery } from "./components/gallery";
import { About } from "./components/ourstory";
import { ContactUs } from "./components/contactUs";
import { EntryPage } from "./components/EntryPage";
import { WeddingPortfolio } from "./components/portfolio/WeddingPortfolio";
import { BirthdayPortfolio } from "./components/portfolio/BirthdayPortfolio";
import { CocktailPortfolio } from "./components/portfolio/CocktailPortfolio";
import { CorporateSocialPortfolio } from "./components/portfolio/CorporateSocialPortfolio";
import { FoodBeveragePortfolio } from "./components/portfolio/FoodBeveragePortfolio";
import { Testimonials } from "./components/testimonials";
import ScrollToTop from "./components/ScrollToTop";

function App() {
  const [hasEntered, setHasEntered] = useState(false);

  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route
          path="/"
          element={
            hasEntered
              ? <Home />
              : <EntryPage onEnter={() => setHasEntered(true)} />
          }
        />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/about-us" element={<About />} />
        <Route path="/contactUs" element={<ContactUs />} />
        <Route path="/testimonials" element={<Testimonials />} />
        <Route path="/portfolio/weddings" element={<WeddingPortfolio />} />
        <Route path="/portfolio/birthdays" element={<BirthdayPortfolio />} />
        <Route path="/portfolio/cocktail" element={<CocktailPortfolio />} />
        <Route path="/portfolio/corporate-social" element={<CorporateSocialPortfolio />} />
        <Route path="/portfolio/food-beverage" element={<FoodBeveragePortfolio />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
